/* global femcare */

/**
 * Represents the product filter functionality.
 */
femcare.product.productFilter = {
    /**
     * Initializes the product filter.
     */
    init: function () {
        this.$filter = $('.product-filter');
        this.$filterChipList = $('.product-filter__list');
        this.$filterOverlay = $('.product-filter__overlay');
        this.$activeChips = $('.product-filter__active-chips');
        this.$filterCloseButton = $('.product-filter__overlay-close');
        this.allRules = [];
        this.allCategoryCriteriaForQueryStrings = [];
        this.usedCategories = [];

        var url = new URL(window.location.href);
        var params = url.search;

        if (this.$filter.length) {
            this.initMembers();
            this.initCategoryObj();
            this.initAccordion();
            this.initOpenFilter();
            this.closeFilterOnAction();
            this.showFilteredItems();
            this.countAllProducts();

            if (!params.length) {
                this.debouncedCountUpdate();
            }

            if (params.length) {
                this.$productList.addClass('product-list--filtered');
                this.readQueryString(params);
                this.applyCriteria();
                this.showChips(this.allCategoryCriteriaForQueryStrings);
                setTimeout(function () {
                    this.invokeFilter(this.allRules);
                    this.debouncedCountUpdate();
                    this.debouncedOccurenceUpdate();
                }.bind(this), 0);
            }

            this.initCheckboxFiltering();
            this.initClearSpecificChip();
        }
    },

    /**
     * Initializes the members of the product filter.
     */
    initMembers: function () {
        this.activeChipClass = 'active';
        this.activeChipSelector = '.product-filter__checkbox.active';
        this.orientation = $('body').hasClass('rtl') ? 'right' : 'left';

        this.$filteredItemsOccurrence = $('.product-filter__occurrences .occurrence');
        this.filteredItemsDefaultVal = this.$filteredItemsOccurrence.first().text();

        this.$clearOption = $('.product-filter__option--clear');
        this.$optionAfterClear = this.$clearOption.next();

        this.$filterChips = $('.product-filter__option');
        this.$chip = $('.product-filter__chip');
        this.$clearChip = $('.product-filter__chip--remove-filter');
        this.$filterCheckboxes = $('.product-filter__checkbox');
        this.$productList = $('.product-list');
        this.$productItems = this.$productList.find('.product-list__item');
        this.$initFilter = $('.init-filter');
    },

    /**
     * Updates the active chips element based on selected filters.
     */
    updateActiveChips: function () {
        const activeFiltersCount = this.$filterCheckboxes.filter('.active').length;

        if (activeFiltersCount === 0) {
            this.$activeChips.addClass('hidden').text('');
            $('.product-filter__overlay-clear').addClass('hidden');
        } else {
            this.$activeChips.removeClass('hidden').text(activeFiltersCount);
            $('.product-filter__overlay-clear').removeClass('hidden');
        }
    },

    /**
     * Toggles the "product-filter__checkbox--checked" class for checkboxes in specific categories.
     * @param {jQuery} $checkbox - The checkbox element.
     * @param {boolean} isChecked - Whether the checkbox is checked.
     */
    toggleCheckedClass: function ($checkbox, isChecked) {
        if ($checkbox.closest('.product-filter__category--absorbency').length) {
            $checkbox.toggleClass('product-filter__checkbox--checked', isChecked);
        }
    },

    /**
     * Initializes the category object by extracting categories from HTML checkboxes.
     * Gets categoties from HTML checkboxes
     */
    initCategoryObj: function () {
        const usedCategories = [];
        this.$filterCheckboxes.each((index, element) => {
            const category = $(element).data('category');
            usedCategories.push(category);
        });

        this.usedCategories = usedCategories.filter(this.onlyUnique);
    },

    /**
     * Filters the checkboxes to only keep unique elements. Takes unique elements from array.
     * @param {*} value - The current value.
     * @param {number} index - The index of the current value.
     * @param {Array} self - The array being traversed.
     * @returns {boolean} - True if the value is unique, false otherwise.
     */
    onlyUnique: function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    },

    /**
     * Initializes the checkbox filtering functionality.
     */
    initCheckboxFiltering: function () {
        this.$filterCheckboxes.on('click', (e) => {
            const $checkbox = $(e.target);
            const isChecked = $checkbox.prop('checked');

            $checkbox.toggleClass(this.activeChipClass, isChecked);
            this.toggleCheckedClass($checkbox, isChecked);
            this.applyCriteria();
            this.showChips(this.allCategoryCriteriaForQueryStrings);
            this.addFilterToQueryString(this.allCategoryCriteriaForQueryStrings);
            this.invokeFilter(this.allRules);
            this.debouncedCountUpdate();
            this.debouncedOccurenceUpdate();
            this.updateActiveChips();
        });
    },

    /**
     * Initializes the clear specific chip functionality.
     */

    initClearSpecificChip: function () {
        this.$clearChip.on('click', (e) => {
            const $clearChip = $(e.target).closest('.product-filter__chip');
            const category = $clearChip.data('category');
            const option = $clearChip.data('option');

            const $checkbox = this.$filterCheckboxes.filter(`[data-category="${category}"][data-option="${option}"]`);
            $checkbox.removeClass(this.activeChipClass).prop('checked', false);
            this.toggleCheckedClass($checkbox, false);
            this.$filterChipList.addClass('hidden');
            $clearChip.closest('.product-filter__option').removeClass('show');

            this.applyCriteria();
            this.invokeFilter(this.allRules);
            this.removeQueryString($clearChip, false);
            this.debouncedCountUpdate();
            this.debouncedOccurenceUpdate();
            this.updateActiveChips();
        });
    },


    /**
     * Initializes the open filter functionality.
     */
    initOpenFilter: function () {
        this.$initFilter.click((e) => {
            e.stopPropagation();
            if (!this.$filterOverlay.hasClass('product-filter__overlay--visible')) {
                this.$filterOverlay.toggleClass('product-filter__overlay--visible');
                this.$filter.find('.product-filter--page-overlay').show();
                this.$filterCloseButton.trigger('focus');
                $('body').css('overflow', 'hidden');
            }
        });
    },

    /**
     * Initializes the close filter functionality.
     */
    initCloseFilter: function () {
        if (this.$filterOverlay.hasClass('product-filter__overlay--visible')) {
            this.$filterOverlay.removeClass('product-filter__overlay--visible');
            this.$filter.find('.product-filter--page-overlay').hide();
            $('body').css('overflow', '');
        }
    },

    /**
     * Closes the filter on user action.
     */
    closeFilterOnAction: function () {
        $('.product-filter--page-overlay, .product-filter__overlay-close').on('click', () => {
            this.initCloseFilter();
        });

        $('.product-filter__overlay-clear').on('click', (e) => {
            // Remove active and specific classes from all checkboxes
            this.$filterCheckboxes.each((index, checkbox) => {
                const $checkbox = $(checkbox);
                $checkbox.removeClass(this.activeChipClass).prop('checked', false);
                this.toggleCheckedClass($checkbox, false);
            });

            this.removeChips(e);
            this.removeQueryString(null, true);
            this.applyCriteria();
            this.invokeFilter(null);
            this.initCloseFilter();
            this.debouncedCountUpdate();
            this.debouncedOccurenceUpdate();
            this.updateActiveChips();
        });
    },

    /**
     * Initializes the accordion functionality.
     */
    initAccordion: function () {
        var $accordion = $('.accordion--filters');
        if ($accordion.length) {
            femcare.general.accordion.init('.accordion--filters', 'content');
        }
    },

    /**
     * Counts all the products and categorizes them by criteria.
     */
    countAllProducts: function () {
        var allProducts = [];
        this.$productItems.each(function (index, product) {
            var criteria = Object.keys($(product).data());
            Array.prototype.push.apply(allProducts, criteria)
        });

        var criteriaObj = {};
        this.usedCategories.forEach(function (key) { criteriaObj[key] = [] });

        var splittedCriteria;
        allProducts.forEach(function (criteria) {
            var category;
            var option;
            if (criteria.includes('-')) {
                splittedCriteria = criteria.split('-');
                category = splittedCriteria[0];
                option = splittedCriteria[1].toLowerCase();
            } else {
                splittedCriteria = criteria.split(/(?=[A-Z])(.*)/);
                category = splittedCriteria[0];
                option = splittedCriteria[1];
            }

            if (category !== 'review') {
                var mixedOption = option.split(/(?=[A-Z])/).join('-').toLowerCase();
            }

            if (criteriaObj[category] !== undefined) {
                criteriaObj[category].push(mixedOption);
            }

        }.bind(this))

        this.allProductsCounted = criteriaObj;
    },

    /**
     * Counts the products based on the selected criteria and updates filter occurrences directly.
     */
    countProductsByCriteria: function () {
        const allCriteria = [];
        const criteriaObj = {};

        // Initialize criteria object for each used category
        this.usedCategories.forEach((key) => {
            criteriaObj[key] = [];
        });

        // Extract all `data-*` attributes from visible products
        this.$productList.find('.product-list__item:not([style*="display: none"])').each(function (index, product) {
            const dataAttributes = Object.keys($(product).data());
            allCriteria.push(...dataAttributes);
        });

        // Populate the criteria object by category
        allCriteria.forEach((criteria) => {
            let category, option;

            if (criteria.includes('-')) {
                // For kebab-case (e.g., data-usage-period-days)
                const splitCriteria = criteria.split(/-(.+)/);
                category = splitCriteria[0];
                option = splitCriteria[1]?.toLowerCase();
            } else {
                // For camelCase (e.g., dataUsagePeriodDays)
                const splitCriteria = criteria.match(/([a-z]+|[A-Z][a-z]*)/g);
                category = splitCriteria[0];
                option = splitCriteria.slice(1).join('-').toLowerCase();
            }

            if (category && option && criteriaObj[category]) {
                criteriaObj[category].push(option);
            }
        });

        // Update occurrences and enable/disable filters
        this.$filterCheckboxes.each((index, element) => {
            const category = $(element).data('category');
            const option = $(element).data('option').toString();

            // Match the option exactly with the criteriaObj
            const occurrences = Array.isArray(criteriaObj[category])
                ? criteriaObj[category].filter((x) => x === option).length
                : 0;

            const occurrenceText = occurrences > 0 ? `(${occurrences})` : "";
            $(element)
                .siblings('.occurrence')
                .add($(element).children('.occurrence'))
                .text(occurrenceText);

            const $formGroup = $(element).closest('.form-group');

            // Enable or disable filters that are not selected based on occurrences
            if (occurrences === 0 && !$(element).hasClass(this.activeChipClass)) {
                $(element).prop('disabled', true);
                $formGroup.addClass('disabled');
            } else {
                $(element).prop('disabled', false);
                $formGroup.removeClass('disabled');
            }
        });
    },

    /**
     * Checks the selected category based on active checkboxes.
     * @returns {string} - The selected category.
     */
    checkSelectedCategory: function () {
        var activeCategories = [];
        this.$filterCheckboxes.each(function (index, element) {
            var activeCheckbox = $(element).hasClass('active');
            if (activeCheckbox) {
                activeCategories.push($(element).data('category'));
            }
        });

        var uniqueCategoryArr = activeCategories.filter(this.onlyUnique);
        if (uniqueCategoryArr.length === 1) {
            return uniqueCategoryArr[0];
        } else {
            return '';
        }
    },

    /**
     * Adds numbers to the filters based on the selected criteria.
     */
    addNumbersToFilters: function () {
        // Update occurrences for standard filters
        this.$filterCheckboxes.each((index, element) => {
            const category = $(element).data('category');
            const option = $(element).data('option').toString();
            const occurrences = this.allProductsCounted[category] ? this.allProductsCounted[category].filter(x => x === option).length : 0;
            $(element)
            .siblings('.occurrence') // Siblings with the class
            .add($(element).children('.occurrence')) // Direct children with the class
            .text(`(${occurrences})`);
        });
    },

    /**
     * Applies the selected criteria and formulates the filtering rules.
     */
    applyCriteria: function () {
        var criteriaObj = {};
        this.usedCategories.forEach(function (key) { criteriaObj[key] = [] });

        this.$filterCheckboxes.filter(this.activeChipSelector).each(function (index, chip) {
            var category = $(chip).data('category');
            var option = $(chip).data('option');

            criteriaObj[category].push({ category: category, option: option });
        });
        var allCategoryCriteria = [];

        var allCriteriaNames = Object.keys(criteriaObj);
        allCriteriaNames.forEach(function (key) {
            if (criteriaObj[key].length) {
                allCategoryCriteria.push(criteriaObj[key]);
            }
        });

        this.allRules = [];
        this.formulateRules(allCategoryCriteria, 0, this.allRules, []);
        this.allCategoryCriteriaForQueryStrings = allCategoryCriteria.flat(1);
    },

    /**
     * Formulates the filtering rules based on the selected criteria.
     * @param {Array} allCategoryCriteria - The category criteria.
     * @param {number} categoryIndex - The index of the current category.
     * @param {Array} allRules - The array of all rules.
     * @param {Array} rule - The current rule being formulated.
     */
    formulateRules: function (allCategoryCriteria, categoryIndex, allRules, rule) {
        // If the criteria selected is x1, x2, y1 and they belong to x and y categories respectively
        // then the matching items must satisfy ( x1 AND y1 ) OR ( x2 AND y1 ).
        // This is can be represented as a cartesian product where the categories are the sets.

        if (allCategoryCriteria.length !== 0) {
            for (var optionIndex = 0; optionIndex < allCategoryCriteria[categoryIndex].length; optionIndex++) {
                var selectedOption = allCategoryCriteria[categoryIndex][optionIndex];
                if (categoryIndex + 1 < allCategoryCriteria.length) {
                    this.formulateRules(allCategoryCriteria, categoryIndex + 1, allRules, rule.concat([selectedOption]));
                } else {
                    this.allRules.push(rule.concat([selectedOption]));
                }
            }
        }
    },

    /**
     * Invokes the filter with the specified rules.
     * @param {Array} rules - The filtering rules.
     */
    invokeFilter: function (rules) {
        this.$filter.trigger('filter', { rules: rules });
        this.activateButtons();
        this.$productList.addClass('product-list--filtered');
        this.$productList.find('.product-list__item:not([style*="display: none"])').addClass('product-list__item--filtered');
    },

    /**
     * Activates or deactivates buttons based on the presence of filtering rules.
     */
    activateButtons: function () {
        if (this.allRules.length !== 0) {
            this.$initFilter.addClass('active');
        } else {
            this.$initFilter.removeClass('active');
        }
    },

    /**
     * Shows the filter chips based on the selected criteria.
     * @param {Array} rules - The selected criteria.
     */
    showChips: function (rules) {
        this.$filterChips.removeClass('show');
        rules.forEach(function (element) {
            var category = element.category;
            var option = element.option;

            this.$filterChipList.removeClass('hidden');
            this.$chip.filter('[data-category="' + category + '"][data-option="' + option + '"]').parent('.product-filter__option').addClass('show');
        }.bind(this));
        this.$filter.find('.product-filter__heading-container').addClass('product-filter__heading-container--translated');
    },

    /**
     * Removes the filter chips based on user action.
     * @param {Event} event - The event object.
     */
    removeChips: function (event) {
        event.preventDefault();
        var $chip = $(event.target);
        var clearAllFilters = false;
        var visiblieChips = this.$filterChips.filter('.show');
        this.$filterChipList.addClass('hidden');

        if ($chip.hasClass('product-filter__overlay-clear') || $chip.hasClass('product-filter__chip--clear')) {
            clearAllFilters = true;
        }

        if (clearAllFilters || visiblieChips.length === 2) {
            visiblieChips.removeClass('show');
        } else {
            var $selectedChip = $chip.parents('.product-filter__option');
            $selectedChip.removeClass('show');
        }

        this.$filter.find('.product-filter__heading-container').removeClass('product-filter__heading-container--translated');
    },

    /**
     * Adds the selected filter criteria to the query string.
     * @param {Array} rules - The selected criteria.
     */
    addFilterToQueryString: function (rules) {
        var url = new URL(window.location.href);
        var clearUrl = url.href.split('?')[0];
        window.history.replaceState(null, '', clearUrl);
        var params = new URLSearchParams(clearUrl.search);

        rules.forEach(function (element) {
            var criteria = element.category + '-' + element.option;
            params.append('f', criteria);
            window.history.replaceState({}, '', '?' + params);
        })
    },

    /**
     * Reads the query string and selects the corresponding filter checkboxes.
     * @param {string} params - The query string parameters.
     */
    readQueryString: function (params) {
        const criteriaPairs = params
            .substring(1)
            .split('&')
            .map(param => param.split('=')[1]);

        criteriaPairs.forEach(element => {
            const [category, option] = element.split(/-(.*)/s);

            // Find checkboxes matching the category and option
            const $checkbox = this.$filterCheckboxes.filter(`[data-category="${category}"][data-option="${option}"]`);

            // Add active and specific classes
            $checkbox.addClass(this.activeChipClass);
            this.toggleCheckedClass($checkbox, true); // Reuse the modular function
        });

        this.updateActiveChips();
    },

    /**
     * Removes the filter criteria from the query string.
     * @param {jQuery} $chipClose - The close button of the chip being removed.
     * @param {boolean} isClearAll - Indicates if all filters are being cleared.
     */
    removeQueryString: function ($chipClose, isClearAll) {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        if (isClearAll) {
            const clearUrl = url.origin + url.pathname;
            window.history.replaceState(null, '', clearUrl);
        } else {
            const category = $chipClose.data('category');
            const option = $chipClose.data('option');
            const criteria = `${category}-${option}`;

            params.delete('f', criteria);
            const updatedUrl = url.origin + url.pathname + '?' + params.toString();
            window.history.replaceState(null, '', updatedUrl);
        }
    },

    /**
     * Unchecks the checkbox associated with the specified chip.
     * @param {jQuery} $chipClose - The close button of the chip.
     */
    uncheckCheckbox: function ($chipClose) {
        var $chipFilter = $chipClose.parents('.product-filter__chip');
        var category = $chipFilter.data('category');
        var option = $chipFilter.data('option');

        this.$filterCheckboxes.filter('[data-category' + category + '],[data-option="' + option + '"]').removeClass('active').prop('checked', false);
    },


    /**
     * Shows the filtered items based on user action.
     */
    showFilteredItems: function () {
        this.$filterOverlay.find('.product-filter__overlay--show-items').click(function () {
            this.showChips(this.allCategoryCriteriaForQueryStrings);
            this.initCloseFilter();
        }.bind(this));

    },

    /**
     * Updates the filtered items occurrence count.
     */
    updateFilteredOccurrence: function () {
        let noOfFilteredItems = this.$productList.find('.product-list__item:not([style*="display: none"])').length;

        if (this.allRules.length === 0) {
            // Reset to default value if no filters are applied
            this.$filteredItemsOccurrence.text(this.filteredItemsDefaultVal);
        } else {
            // Update with the number of items that match the filter
            this.$filteredItemsOccurrence.text(noOfFilteredItems);
        }
    },

    /**
     * Updates the filtered items occurrence count after a delay to ensure all DOM updates are complete.
     * This debounce is used to prevent frequent updates during rapid changes, such as when multiple filters
     * are applied or removed quickly, ensuring that the displayed count only updates after the last change.
     */
    debouncedOccurenceUpdate: function () {
        const debounceUpdateFilteredOccurrence = femcare.shared.util.debounce(() => {
            this.updateFilteredOccurrence();
        }, 500);

        debounceUpdateFilteredOccurrence();
    },

    /**
     * Recalculates and displays the number of products matching the filter criteria after a delay.
     * The debounce is utilized to optimize performance by limiting the frequency of recalculations,
     * which might otherwise be triggered excessively in response to rapid, successive changes in the filter settings.
     */
    debouncedCountUpdate: function () {
        const debounceCountProducts = femcare.shared.util.debounce(() => {
            this.countProductsByCriteria();
        }, 300);

        debounceCountProducts();
    }
};
